import { Button } from '@chakra-ui/button'
import {
  Text,
  Box,
  VStack,
  useDisclosure,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Link
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router'
import shallow from 'zustand/shallow'
import { Link as RouterLink } from 'react-router-dom'
import { BaseHeading, Layout, Loader } from '../../../components'
import { ControlledInput, Input } from '../../../components/form'
import { ROUTES } from '../../../contants'
import useMotorStore from '../../../state/Motor.store'
import { screens } from './types'
import { PLATE_NUMBER, PIN } from '../../../utils/validations'

const Motor = () => {
  const history = useHistory()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [loading, fetchNiid, setScreen] = useMotorStore(
    (state) => [state.loading, state.fetchNiid, state.setScreen],
    shallow
  )

  const {
    handleSubmit,
    formState: { errors, touchedFields, isValid },
    watch,
    control
  } = useForm({
    mode: 'onChange',
    defaultValues: { plate: '' }
  })
  const onSubmit = async (data: any) => {
    try {
      await fetchNiid(data.plate)
      setScreen(screens.MOTOR_DETAILS)
    } catch (error) {
      onOpen()
    }
  }

  return (
    <Layout title="Motor Insurance">
      <Loader text="Checking NIID database..." loading={loading} />
      <BaseHeading title="Please Enter Vehicle Plate Number" />
      <Box as="form" onSubmit={handleSubmit(onSubmit)}>
        <Text fontSize="1.2rem" mb="2rem">
          Enter Vehicle Plate Number to proceed
        </Text>

        <Controller
          control={control}
          rules={PLATE_NUMBER}
          name="plate"
          render={({ field }) => (
            <ControlledInput
              isValid={watch('plate') && !errors.plate && true}
              isError={errors.plate && errors.plate.message}
              label="Vehicle Plate Number"
              id="plate"
              value={field.value}
              onChange={(e) => {
                if (e.target.value.length > 15) {
                  e.preventDefault()
                  return
                }
                field.onChange(e)
              }}
            />
          )}
        />

        <Modal size="md" isCentered isOpen={isOpen} onClose={onClose}>
          <ModalOverlay bg="rgba(0, 0, 0, 0.9)" />
          <ModalContent rounded="12px" px="1rem" maxW={{ md: '320px !important' }} mx="auto">
            <ModalBody p="5rem" as={VStack} textAlign="center">
              <svg
                width="157"
                height="47"
                viewBox="0 0 157 47"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d)">
                  <path
                    d="M11 3H146C147.326 3 148.598 3.52678 149.536 4.46447C150.473 5.40215 151 6.67392 151 8V33C151 34.3261 150.473 35.5979 149.536 36.5355C148.598 37.4732 147.326 38 146 38H11C9.67392 38 8.40215 37.4732 7.46447 36.5355C6.52678 35.5979 6 34.3261 6 33V8C6 6.67392 6.52678 5.40215 7.46447 4.46447C8.40215 3.52678 9.67392 3 11 3V3Z"
                    fill="white"
                  />
                </g>
                <path
                  opacity="0.5"
                  d="M75 11H49C47.3431 11 46 12.3431 46 14C46 15.6569 47.3431 17 49 17H75C76.6569 17 78 15.6569 78 14C78 12.3431 76.6569 11 75 11Z"
                  fill="#FF1B1B"
                />
                <path
                  opacity="0.2"
                  d="M93 24H49C47.3431 24 46 25.3431 46 27C46 28.6569 47.3431 30 49 30H93C94.6569 30 96 28.6569 96 27C96 25.3431 94.6569 24 93 24Z"
                  fill="#FF1B1B"
                />
                <path
                  d="M33 6H14C11.2386 6 9 8.23858 9 11V30C9 32.7614 11.2386 35 14 35H33C35.7614 35 38 32.7614 38 30V11C38 8.23858 35.7614 6 33 6Z"
                  fill="#FF1B1B"
                />
                <path
                  d="M21.2217 23.78H23.2217L23.2437 23.01C23.2437 21.998 23.8817 21.734 24.7837 21.448C25.6885 21.1906 26.4849 20.6456 27.0525 19.8955C27.6201 19.1453 27.928 18.2307 27.9297 17.29C27.9495 16.7157 27.8499 16.1435 27.6371 15.6096C27.4244 15.0758 27.1031 14.5919 26.6936 14.1886C26.2842 13.7854 25.7954 13.4715 25.2584 13.2669C24.7214 13.0623 24.1477 12.9714 23.5737 13C22.9671 12.9868 22.3642 13.0969 21.8014 13.3237C21.2387 13.5505 20.7279 13.8893 20.3 14.3194C19.8721 14.7495 19.536 15.2621 19.3122 15.8261C19.0883 16.39 18.9813 16.9935 18.9977 17.6H21.0657C21.0579 17.2651 21.1169 16.9321 21.2395 16.6203C21.362 16.3085 21.5455 16.0244 21.7793 15.7845C22.0131 15.5445 22.2924 15.3537 22.6009 15.2231C22.9093 15.0925 23.2408 15.0248 23.5757 15.024C23.8778 15.0065 24.1801 15.0542 24.4621 15.1639C24.7441 15.2737 24.9992 15.4428 25.21 15.6599C25.4208 15.8769 25.5824 16.1368 25.6838 16.4219C25.7852 16.707 25.8241 17.0106 25.7977 17.312C25.7844 17.7999 25.6147 18.2706 25.3137 18.6548C25.0127 19.039 24.5963 19.3164 24.1257 19.446L23.3997 19.734C22.6889 19.9053 22.0684 20.3372 21.6609 20.9443C21.2535 21.5514 21.0889 22.2893 21.1997 23.012L21.2217 23.78ZM22.2117 28.534C22.4076 28.541 22.6028 28.5086 22.7859 28.4388C22.9691 28.369 23.1363 28.2632 23.2778 28.1276C23.4194 27.9921 23.5323 27.8295 23.6099 27.6496C23.6875 27.4696 23.7282 27.276 23.7297 27.08C23.728 26.8842 23.687 26.6908 23.6093 26.5111C23.5316 26.3313 23.4186 26.169 23.2771 26.0337C23.1356 25.8984 22.9685 25.7927 22.7855 25.723C22.6025 25.6534 22.4074 25.6211 22.2117 25.628C22.0161 25.6211 21.821 25.6534 21.638 25.723C21.455 25.7927 21.2878 25.8984 21.1463 26.0337C21.0048 26.169 20.8919 26.3313 20.8142 26.5111C20.7364 26.6908 20.6955 26.8842 20.6937 27.08C20.6952 27.276 20.736 27.4696 20.8136 27.6496C20.8912 27.8295 21.0041 27.9921 21.1456 28.1276C21.2871 28.2632 21.4544 28.369 21.6375 28.4388C21.8206 28.5086 22.0159 28.541 22.2117 28.534Z"
                  fill="white"
                />
                <defs>
                  <filter
                    id="filter0_d"
                    x="0"
                    y="0"
                    width="157"
                    height="47"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              <Text fontSize="1.4rem" color="black">
                Vehicle Details Not Found in NIID Database.
              </Text>
            </ModalBody>

            <ModalFooter mb="0.5rem" justifyContent="center">
              <Text
                fontWeight="500"
                color="brand.blue"
                onClick={() => setScreen(screens.ENTER_DETAILS)}
                d="block"
                textAlign="center"
                _hover={{ border: 'none', outline: 'none' }}
                _active={{ border: 'none', outline: 'none' }}
                _focus={{ border: 'none', outline: 'none' }}>
                Enter Details Manually
              </Text>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Button isDisabled={!isValid} type="submit" isFullWidth variant="blue">
          Submit
        </Button>
      </Box>
    </Layout>
  )
}

export { Motor }
